import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Header,Button, Input } from "semantic-ui-react";
import Chart from "./chart";
import TableHistoric from "../tables/TableHistoric";
import { removeFromList } from "../../actions/graphListActions";

class ChartListItem extends Component {
  state = { shortList: [], startDate:"", endDate:"" };

  handleRemoveClick = code => {
    const newList = this.props.graphsList.filter(graph => graph.code !== code);
    this.props.removeFromList(newList);
  };

  getChartItems = list => {
    this.setState({ shortList: list });
  };

  filterByDate = () => {
    const {startDate, endDate} = this.state;
    const {chart} = this.props;
    console.log(startDate, endDate)
    if(!startDate || !endDate) return;

    const filtered = chart.data.filter(item => {
      console.log(item)
      //const [day,mon,year] = item.fecha_recepcion.split("-");
      const itemDate = item.fecha_recepcion_original;
      console.log(itemDate)
      return itemDate >= startDate && itemDate <= endDate;
      //console.log(day,mon,year)
      /*const months = {
        Ene:"01", Feb:"02",Mar:"03",Abr:"04",
        May:"05",Jun:"06",Jul:"07",Ago:"08",
        Sep:"09", Oct:"10",Nov:"11",Dec:"12"
      }
      const formatted =  `${year}-${months[mon]}-${day}`;
      console.log(formatted, endDate, startDate)
      if(formatted >= startDate){
        console.log("Encima de la fecha")
      }else if(formatted <= endDate){
        console.log("Debajo de la fecha")
      }
      return formatted >= startDate && formatted <= endDate;*/
    })

    console.log("filtered",filtered)
    console.log("Short list actual:", this.state.shortList);
    this.setState({shortList : filtered}) //le envia bien el filtro pero igual lo renderiza
  }

  /*componentWillMount() {
    this.props.chart.data.sort((a, b) => {
      const aa = a.fecha_recepcion.split("-").join();
      const bb = b.fecha_recepcion.split("-").join();
      return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
    this.props.chart.data.forEach(e => {
      const tempDate = e.fecha_recepcion.slice(0, 10);
      e.fecha_recepcion = tempDate;
    });
    this.props.chart.data.forEach(e => {
      const splitedDate = e.fecha_recepcion.split("-");
      const month = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ][Number(splitedDate[1]) - 1];
      const formatedDate = splitedDate[2] + "-" + month + "-" + splitedDate[0];
      e.fecha_recepcion = formatedDate;
    });
  }*/

  componentDidMount() {
      const chartData = [...this.props.chart.data].map(e => {
        const isoDate = e.fecha_recepcion.slice(0, 10); // YYYY-MM-DD
        const [year, month, day] = isoDate.split("-");
        const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dec"];
        const displayDate = `${day}-${months[parseInt(month, 10) - 1]}-${year}`;
    
        return {
          ...e,
          fecha_recepcion_original: isoDate, // guardar ISO
          fecha_recepcion: displayDate       // mostrar bonita
        };
      });
    
      this.props.chart.data = chartData; // (Idealmente deberías evitar mutar props)
  }

  render() {
    const { chart, goToRef, results } = this.props;
    const { shortList } = this.state;

    const obj = results.find(e => {
      return e.parametro_id === chart.code;
    });

    return (
      <Segment
        color="blue"
        key={chart.code}
        style={{ paddingBottom: 10, paddingTop: 10 }}
      >
        
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Header>{obj.parametro}</Header>
          <i
            onClick={() => this.handleRemoveClick(chart.code)}
            style={{ cursor: "pointer", color: "#00ACC9" }}
            className="glyphicon glyphicon-remove"
          />
        </div>
        <div style={{ marginBottom: "1em"}}>
          <div>
            <Input type="date" onChange={e=>this.setState({ startDate:e.target.value })}>
            </Input>
            <Input type="date" onChange={e=>this.setState({ endDate:e.target.value })} style={{ marginLeft: "1em"}}>
            </Input>
            <Button color="blue" onClick={this.filterByDate} style={{narginLeft: "1em"}} >
              Aplicar filtro
            </Button>
          </div>
        </div>
        <h4>
          Referencia: {chart.data[0].referencia} {chart.data[0].unidad}
        </h4>
        <Chart
          selectedGraph={
            this.state.startDate && this.state.endDate ? shortList : chart.data.slice(0,10)
            //shortList.length === 0 ? chart.data.slice(0, 10) : shortList
          }
        />
        <TableHistoric
          getChartItems={this.getChartItems.bind(this)}
          chart={chart}
          goToRef={goToRef}
        />
      </Segment>
    );
  }
}

const mapStateToProps = state => {
  return {
    results: state.patientOrderResults.order.results,
    graphsList: state.graphsList
  };
};

export default connect(
  mapStateToProps,
  { removeFromList }
)(ChartListItem);
